import { FileText, Trash2 } from "lucide-react";

function formatDate(timestamp) {
  return new Date(timestamp).toLocaleDateString([], { month: "short", day: "numeric", year: "numeric" });
}

export default function DocumentLibraryManager({ documents, onDelete, deletingDocument }) {
  return (
    <section className="admin-section document-library-manager" data-testid="admin-document-library">
      <div><span className="eyebrow">Investor materials</span><h2>DOCUMENT LIBRARY</h2></div>
      {documents.length ? <div className="admin-document-list" data-testid="admin-document-list">
        {documents.map((document) => <article key={document.document_id} data-testid={`admin-document-${document.document_id}`}>
          <FileText size={20} />
          <div><span>{document.category}</span><h3>{document.title}</h3><p>{document.filename} · {formatDate(document.created_at)}</p></div>
          <button className="icon-button document-delete-button" type="button" title="Remove document" disabled={deletingDocument === document.document_id} onClick={() => onDelete(document)} data-testid={`delete-document-${document.document_id}`}><Trash2 size={16} /></button>
        </article>)}
      </div> : <div className="empty-state" data-testid="admin-document-empty-state">No active investor documents yet.</div>}
    </section>
  );
}